import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as setupStatusState from '../reducers';
import * as saveTaxNumberReducer from '../reducers/save-tax-number.reducer';

export const selectSaveTaxNumber = createSelector(
  setupStatusState.GetSaveTaxNumberState,
  saveTaxNumberReducer.getSaveTaxNumberResponse
);
